import script from "./SpvForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SpvForm.vue?vue&type=script&setup=true&lang=js"

import "./SpvForm.vue?vue&type=style&index=0&id=6e288712&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e288712"]])

export default __exports__